import { createAction } from '@reduxjs/toolkit';
import type { Category, Customer, ErrorData, Model, RuleRevision, UUID } from 'types';

export const editCategory = createAction<{ category: Category; ruleId: string }>(
  'BULK_OUTCOMES/EDIT_CATEGORY'
);

export const addCategories = createAction<{ categories: Partial<Category>[]; rule: RuleRevision }>(
  'BULK_OUTCOMES/ADD_CATEGORIES'
);

export const deleteCategories = createAction<{
  categories: string[];
  ruleId: string;
}>('BULK_OUTCOMES/DELETE_CATEGORIES');

export const setRules =
  createAction<{ rule: RuleRevision; categories: Category[] }[]>('BULK_OUTCOMES/SET_RULES');

export const selectCustomerBulkOutcomes = createAction<Customer>('BULK_OUTCOMES/SELECT_CUSTOMER');

export const selectFromCustomerBulkOutcomes = createAction<UUID>(
  'BULK_OUTCOMES/SELECT_FROM_CUSTOMER'
);

export const selectUseCaseBulkOutcomes = createAction<Model>('BULK_OUTCOMES/SELECT_USE_CASE');

export const upsertBulkCategories = createAction('BULK_OUTCOMES/UPSERT_BULK_CATEGORIES');
export const upsertBulkCategoriesRequest = createAction(
  'BULK_OUTCOMES/UPSERT_BULK_CATEGORIES_REQUEST'
);
export const upsertBulkCategoriesSuccess = createAction(
  'BULK_OUTCOMES/UPSERT_BULK_CATEGORIES_SUCCESS'
);
export const upsertBulkCategoriesFailure = createAction<ErrorData>(
  'BULK_OUTCOMES/UPSERT_BULK_CATEGORIES_FAILURE'
);
